
import { addDoc, collection, doc, getDoc, getDocs, query, setDoc, where } from "firebase/firestore";
import { instance } from "./mainAxios";
import { auth, db } from "./firabaseConfig";
import classRequets from "./classRequest";
import { createUserWithEmailAndPassword } from "firebase/auth";
const mainPath = "/admin";


// const getAllTeachers = () => {
//     const path = mainPath + "/getAllTeachers";

//     return new Promise(async (resolve, reject) => {
//         try {
//             const res = await instance.get(path);
//             resolve(res.data);
//         } catch (error) {
//             reject(error);
//         }
//     });
// };
const getAllTeachers = async () => {
    const userRef = collection(db, "users");
    let q = query(userRef, where("permissions", "in", ["admin", "teacher"]));
    let admins = [];
    let userSnap = (await getDocs(q)).docs;

    // Use Promise.all to wait for all the async operations to complete
    await Promise.all(userSnap.map(async doc => {
        let teacherDetails = { ...doc.data(), id: doc.id };
        if (!teacherDetails.isActive) { return }
        let teacherClasses = await classRequets.getAllTeacherClasses(doc.id);
        if (teacherClasses) {
            teacherDetails.classes = teacherClasses;
        } else {
            teacherDetails.classes = []
        }
        admins.push(teacherDetails);
    }));

    console.log("🚀 ~ getAllTeachers ~ admins:", admins)
    return admins;
};

const getOneTeacherClasses = (class_id) => {
    const path = mainPath + "/getClass/" + class_id;

    return new Promise(async (resolve, reject) => {
        try {
            const res = await instance.get(path);
            resolve(res);
        } catch (error) {
            reject(error);
        }
    });
};

//Login
const getNewClassId = () => {
    const path = mainPath + "/generateClassId";
    return new Promise(async (resolve, reject) => {
        try {
            const res = await instance.get(path);
            resolve(res);
        } catch (error) {
            reject(error);
        }
    });
};
const createNewTeacher = async (teacherDetails) => {
    try {
        let saveNewUserToStore;
        let checkIfUserExict = await getUserDetailsByEmail(teacherDetails.email);
        console.log("🚀 ~ adminRequests.js:74 ~ createNewTeacher ~ checkIfUserExict:", checkIfUserExict)
        if (!checkIfUserExict) {
            let newUser = await createUserWithEmailAndPassword(auth, teacherDetails.email, teacherDetails.pass);
            console.log("🚀 ~ createNewTeacher ~ newUser:", newUser)
            saveNewUserToStore = await createNewUser(newUser, teacherDetails)
        } else {
            if (!checkIfUserExict.isActive) {
                let reActiveUser = await editUserDetails(checkIfUserExict.id, { isActive: true });
                saveNewUserToStore = reActiveUser
                console.log("🚀 ~checkIfUserExict.isActive", saveNewUserToStore)
            }
            if (checkIfUserExict.permissions != teacherDetails.role) {
                {
                    let reActiveUser = await editUserDetails(checkIfUserExict.id, { permissions: teacherDetails.role });
                    saveNewUserToStore = reActiveUser
                    console.log("🚀 checkIfUserExict.permissions != teacherDetails.role", saveNewUserToStore)
                }
            }
        }
        console.log("🚀 ~ createNewTeacher ~ saveNewUserToStore:", saveNewUserToStore)
    } catch (error) {
        console.log("🚀 ~ file: adminRequests.js:78 ~ createNewTeacher ~ error:", error.code)
        throw error
    }
};
// const createNewTeacher = (teacherDetails) => {
//     const path = mainPath + "/createTeacer";
//     return new Promise(async (resolve, reject) => {
//         try {
//             const res = await instance.post(path, teacherDetails);
//             resolve(res);
//         } catch (error) {
//             reject(error);
//         }
//     });
// };
// const editUserDetails = (user_id, newUserDetails) => {
//     const path = mainPath + "/updateUserDeatils/" + user_id;

//     return new Promise(async (resolve, reject) => {
//         try {
//             const res = await instance.put(path, newUserDetails);
//             resolve(res);
//         } catch (error) {
//             reject(error);
//         }
//     });
// };
const editUserDetails = async (user_id, newUserDetails) => {

    const cityRef = doc(db, 'users', user_id);
    let updateClassDetails = await setDoc(cityRef, { ...newUserDetails }, { merge: true });
    return updateClassDetails

};

// const deleteUser = (user_id) => {
//     const path = mainPath + "/updateUserDeatils/" + user_id;
//     const body = { isActive: false }
//     return new Promise(async (resolve, reject) => {
//         try {
//             const res = await instance.put(path, body);
//             resolve(res);
//         } catch (error) {
//             reject(error);
//         }
//     });
// };
const deleteUser = async (user_id) => {
    const cityRef = doc(db, 'users', user_id);
    // let updateClassDetails = await setDoc(cityRef, { isActive: false }, { merge: true });
    let updateClassDetails = await setDoc(cityRef, { permissions: "viewer" }, { merge: true });
    return updateClassDetails
};
const createNewUser = async (currentUser, formData) => {
    try {
        let user = await getUserDetailsByEmail(formData.email)
        if (user) {
            return user
        } else {
            let [firstName, lastName] = formData.fullName.split(" ");

            // User doesn't exist, create a new record in the user collection
            const randomNumber = Math.floor(Math.random() * 10); // Generates a random integer between 0 (inclusive) and 11 (exclusive)

            const newUser = {
                permissions: formData.role,
                lastName: lastName ? lastName : " ", // Use displayName from Google if available
                assessments: [],
                assessmentsSeen: [],
                assessmentsCurrIndex: randomNumber,
                email: formData && formData.email ? formData.email.toLowerCase() : formData.email,
                isActive: true,
                image: '', // Use photoURL from Google if available
                TR: [],
                firstName: firstName, // Use displayName from Google if available
                TF: [],
                classId: null,
                calibration: '',
                password: '', // No need to store password when using Google auth
                level: null // Set the initial level here
            };
            const userRef = collection(db, "users");
            let AddingUser = await addDoc(userRef, newUser)
            let fullUserDatails = await getUserDetailsByEmail(currentUser.email)
            console.log("🚀 ~ createNewUser ~ fullUserDatails:", fullUserDatails)
            return fullUserDatails;
        }
    } catch (error) {
        console.log("🚀 ~ createNewUser ~ error:", error)
        throw error
    }
}

async function getUserDetailsByEmail(email) {
    try {
        const userRef = collection(db, "users");
        let q = query(userRef, where("email", "==", email));
        let userSnap = (await getDocs(q)).docs.map(doc => ({ ...doc.data(), id: doc.id }));
        let user = userSnap[0]
        if (user) {
            console.log("🚀 ~ getUserDetailsByEmail ~ user:", user)

            return user
        } else {
            return false
        }
    } catch (error) {
        console.log("🚀 ~ file: userRequests.js:58 ~ getUserDetails ~ error:", error)

    }

};
//
//
const adminRequets = { getAllTeachers, getNewClassId, createNewTeacher, editUserDetails, deleteUser, getOneTeacherClasses };
export default adminRequets;
